import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import ProcessVisualizationWidgetWrapper from '../components/common/ProcessVisualizationWidgetWrapper';

const ProcessVisualizationPage = () => {
  const [dbSource, setDbSource] = useState('mixed_events');
  const [selectedNode, setSelectedNode] = useState(null);
  const [filterInfo, setFilterInfo] = useState(null);

  const handleNodeClick = (nodeData) => {
    console.log('Node clicked:', nodeData);
    setSelectedNode(nodeData);
  };

  const handleFilterChange = (filterData) => {
    console.log('Filter changed:', filterData);
    setFilterInfo(filterData);
  };

  const handleDataLoad = (processData) => {
    console.log('Process data loaded:', processData);
  };

  const handleDataError = (error) => {
    console.error('Data loading error:', error);
  };

  return (
    <Container fluid className="py-4">
      <Row className="">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <h2>Process Visualization</h2>
            <div className="d-flex align-items-center gap-3">
              <Form.Label className="mb-0">Data Source:</Form.Label>
              <Form.Select 
                value={dbSource}
                onChange={(e) => setDbSource(e.target.value)}
                style={{ width: '200px' }}
              >
                <option value="mixed_events">Mixed Events</option>
                <option value="native_events">Native Events</option>
                <option value="source_events">Source Events</option>
              </Form.Select>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
          <ProcessVisualizationWidgetWrapper
            dbSource={dbSource}
            onNodeClick={handleNodeClick}
            onFilterChange={handleFilterChange}
            onDataLoad={handleDataLoad}
            onDataError={handleDataError}
          />
      </Row>

    </Container>
  );
};

export default ProcessVisualizationPage;